/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateCountryRequestViewModel } from "../types/CreateCountryRequestViewModel.ts";

export const createCountryRequestViewModelSchema = z.object({
  code: z.string().nullish(),
  name: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<CreateCountryRequestViewModel>;
